import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {OfflineNodeApiService} from '../../../../services/api/network/offline/node/offline-node-api.service';
import {OfflineRoutingInterfaceApiService} from '../../../../services/api/network/offline/routing-interface/offline-routing-interface-api.service';
import {OperatorsSettingsApiService} from '../../../../services/api/settings/administration/operators/operators-settings-api.service';
import {CredentialsSettingsApiService} from '../../../../services/api/settings/administration/credentials/credentials-settings-api.service';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {NodesDialogService} from '../../../nodes/nodes-dialog/nodes-dialog.service';
import {AddOfflineNodeDialogComponent} from '../../../offline-map/dialogs/add-offline-node-dialog/add-offline-node-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {NodesThirdPartyDialogComponent} from '../../../nodes/nodes-third-party-dialog/nodes-third-party-dialog.component';
import {OfflineMapService} from '../../map/offline-map/offline-map.service';
import {ConfirmationDialogComponent} from '../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../../../services/common/snack-bar/snack-bar.service';
import {EditOfflineNodeDialogComponent} from '../../../offline-map/dialogs/edit-offline-node-dialog/edit-offline-node-dialog.component';
import {ImportNodeFromTopologyDialogComponent} from '../../../offline-map/dialogs/import-node-from-topology-dialog/import-node-from-topology-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OfflineNodeService {

  constructor(private offlineNodeApiService: OfflineNodeApiService,
              private offlineRoutingInterfaceApiService: OfflineRoutingInterfaceApiService,
              private operatorsApiService: OperatorsSettingsApiService,
              private credentialsApiService: CredentialsSettingsApiService,
              private userPrivilege: UserPrivilegeService,
              private nodesDialogService: NodesDialogService,
              private offlineMapService: OfflineMapService,
              public snackBarService: SnackBarService,
              private nodeApiService: NodeApiService,
              public dialog: MatDialog) {
  }

  public lockNode(id: number): void {
    this.offlineNodeApiService.lockNode(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockNode(id: number): void {
    this.offlineNodeApiService.unlockNode(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public unlockNodes(ids: number[]): void {
    this.offlineNodeApiService.unlockNodes(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public lockNodes(ids: number[]): void {
    this.offlineNodeApiService.lockNodes(ids).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public addThirdPartyDevice(node): void {
    const nodeToAdd = _.cloneDeep(node);

    const dialogRef = this.dialog.open(NodesThirdPartyDialogComponent, {
      width: '800px',
      minHeight: '400px',
      data: {
        selectedItem: nodeToAdd
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.offlineNodeApiService.addNode(result.selectedItem).then(() => {
        this.refreshDiagram();
        dialogRef.close();
        this.offlineMapService.removeDraggedSvg();
      }).catch(() => {});
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      dialogRef.close();
      this.offlineMapService.removeDraggedSvg();
    });
  }

  public editThirdPartyDevice(id: number): void {
    Promise.all([
      this.offlineNodeApiService.getNodeForMap(id),
      this.offlineRoutingInterfaceApiService.getRoutingInterfacesForMap({filter: {nodeId: id}})
    ]).then(data => {
      const node = data[0];
      node.routingInterfaces = data[1].filter(ri => {
        return ri.udpPort > -1;
      });
      this.openUpdateOfflineThirdPartyDeviceDialog(node);
    });
  }

  public editNode(id: number): void {
    const isAuthorized = this.userPrivilege.isAuthorized();

    Promise.all([
      this.offlineNodeApiService.getNodeForMap(id),
      isAuthorized ? this.operatorsApiService.getOperators({
        filter: { type: { operator: '=', value: ['DEVICE']} }}).toPromise() : [],
      isAuthorized ? this.credentialsApiService.getCredentials('DEVICE', {}).toPromise() : []])
      .then(data => {
        const nodeToAdd = _.cloneDeep(data[0]);
        const dialogRef = this.dialog.open(EditOfflineNodeDialogComponent, {
          width: '650px',
          data: {
            selectedItem: nodeToAdd,
            nodeUsers: data[1],
            nodeCredentials: data[2]
          }
        });

        dialogRef.componentInstance.onApply.subscribe(result => {
          this.updateAddressProperty(result.selectedItem);
          this.offlineNodeApiService.editNode(result.selectedItem, id).then(() => {
            this.refreshDiagram();
            dialogRef.close();
          }).catch(() => {});
        });

        dialogRef.componentInstance.onCancel.subscribe(() => {
          dialogRef.close();
        });
      });
  }

  public addNode(node): void {
    const nodeToAdd = _.cloneDeep(node);
    nodeToAdd.isOffline = true;

    const dialogRef = this.dialog.open(AddOfflineNodeDialogComponent, {
      width: '650px',
      data: {
        selectedItem: nodeToAdd
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.offlineNodeApiService.addNode(result.selectedItem).then(() => {
        this.refreshDiagram();
        dialogRef.close();
        this.offlineMapService.removeDraggedSvg();
      }).catch(() => {
        this.offlineMapService.removeDraggedSvg();
      });
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      dialogRef.close();
      this.offlineMapService.removeDraggedSvg();
    });

    /*const nodeToAdd = _.cloneDeep(node);
    nodeToAdd.isOffline = true;

    const onSubmit = () => {
      this.offlineNodeApiService.addNode(nodeToAdd).then(() => {
        this.refreshDiagram();
        // this.sharedEventService.broadcast('closeOfflineNodeAddDialog');
      }).catch(() => {});
    };*/

    // this.sharedEventService.broadcast('openOfflineNodeAddDialog', nodeToAdd, onSubmit);
  }

  public deleteNode(node): void {
    const confirmationMessage = `Are you sure you want to delete this node: "${node.name}" ?`;

  /*  this.sharedEventService.broadcast('openConfirmationDialogWindow', confirmationMessage, 'Delete', () => {
      this.offlineNodeApiService.deleteNode(node.id).then(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
        this.refreshDiagram();
      }).catch(() => {
        this.sharedEventService.broadcast('closeConfirmationDialogWindow');
      });
    });*/

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.offlineNodeApiService.deleteNode(node.id).then(() => {
        dialogRef.close();
        this.snackBarService.display(`${node.name} successfully deleted`);
        this.refreshDiagram();
      }).catch((error) => {
        console.log(`Exception was thrown in remove node ${node.name}, reason: ${error}`);
      });
    });
  }

  public exportNodeToTopology(id: number): void {
    this.offlineNodeApiService.exportNodeToTopology(id).then(() => {
      this.refreshDiagram();
    }).catch();
  }

  public importNodeFromTopology(id: number): void {
    this.offlineNodeApiService.importNodeFromTopology(id).then(() => {
      this.refreshDiagram();
    }).catch(() => {});
  }

  public importNodesFromTopology(): void {
    Promise.all([this.offlineNodeApiService.getNodesForMap(), this.nodeApiService.getNodes()]).then((value) => {
      const offlineNodes = value[0];
      const onlineNodes = value[1];

      const alreadyImportedOfflineNodes = offlineNodes.filter((offlineNode) => {
        return !offlineNode.isOffline;
      });

      const filteredNodes = onlineNodes.filter((node) => {
        const alreadyExportedNode = alreadyImportedOfflineNodes.find((offlineNode) => {
          return node.id === offlineNode.id;
        });
        return !alreadyExportedNode || alreadyExportedNode === null;
      });

      const dialogRef = this.dialog.open(ImportNodeFromTopologyDialogComponent, {
        width: '650px',
        data: {
          selectedNodes: [],
          nodes: filteredNodes
        }
      });

      dialogRef.componentInstance.onApply.subscribe(selectedNodes => {
        this.offlineNodeApiService.importNodesFromTopology(selectedNodes).then(() => {
          this.refreshDiagram();
          dialogRef.close();
        }).catch(() => {});
      });

      dialogRef.componentInstance.onCancel.subscribe(() => {
        dialogRef.close();
      });
    });
  }

  private refreshDiagram(): void {
    this.offlineMapService.refresh();
  }

  private openUpdateOfflineThirdPartyDeviceDialog(node): void {
    const nodeToAdd = _.cloneDeep(node);

    const dialogRef = this.dialog.open(NodesThirdPartyDialogComponent, {
      width: '800px',
      minHeight: '400px',
      data: {
        selectedItem: nodeToAdd,
        isEditMode: true
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.offlineNodeApiService.editNode(result.selectedItem, node.id).then(() => {
        this.refreshDiagram();
        dialogRef.close();
        this.offlineMapService.removeDraggedSvg();
      }).catch(() => {});
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      dialogRef.close();
      this.offlineMapService.removeDraggedSvg();
    });
  }

  private openUpdateOfflineNodeDialog(dataObject): void {
    const onSubmit = () => {
      this.updateAddressProperty(dataObject.node);
      this.offlineNodeApiService.editNode(dataObject.node, dataObject.node.id).then(value => {
        this.refreshDiagram();
        // this.sharedEventService.broadcast('closeOfflineNodeEditDialog');
      }).catch(() => {});
    };

/*    this.sharedEventService.broadcast('openOfflineNodeEditDialog',
      dataObject.node,
      dataObject.nodeUsers,
      dataObject.nodeCredentials,
      onSubmit);*/
  }

  private updateAddressProperty(node): void {
    if (node.isIpAddressProvidedForGUI === true) {
      node.ipAddr = node.addressForGUI;
      node.hostname = null;
    } else {
      node.hostname = node.addressForGUI;
      node.ipAddr = null;
    }
  }
}
